/* eslint-disable react/prop-types */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AFPTable, EmptyState } from '@gsa/afp-component-library';
import { emDashUnicode } from '../../../utilities/constants';
import {
  getETDateTimeStr,
  getUSDateTimeStr,
} from '../components/contract-helpers';

export const getColumns = (
  contractHeaderId,
  contractLineId,
  maxContractHeaderHistoryVersionNumber,
  maxContractLineVersionNumber,
) => [
  {
    Header: 'Contract version',
    accessor: 'contractVersion',
    sortable: true,
    Cell: ({ value }) => {
      if (value === maxContractHeaderHistoryVersionNumber) {
        return (
          <RouterLink
            to={`/catalog/contract/contract-header/${contractHeaderId}/`}
            className="text-bold margin-left-1"
          >
            {value}
          </RouterLink>
        );
      }

      return (
        <RouterLink
          to={`/catalog/contract/contract-header/${contractHeaderId}/history/${value}`}
          className="text-bold margin-left-1"
        >
          {value}
        </RouterLink>
      );
    },
  },
  {
    Header: 'Contract line version',
    accessor: 'contractLineVersion',
    sortable: true,
    Cell: ({ value }) => {
      if (value === maxContractLineVersionNumber) {
        return (
          <RouterLink
            to={`/catalog/contract/${contractHeaderId}/contract-line-template/${contractLineId}/`}
            className="text-bold margin-left-1"
          >
            {value}
          </RouterLink>
        );
      }
      return (
        <RouterLink
          to={`/catalog/contract/${contractHeaderId}/contract-line-template/${contractLineId}/history/${value}`}
          className="text-bold margin-left-1"
        >
          {value}
        </RouterLink>
      );
    },
  },
  {
    Header: 'Modification number',
    accessor: 'modTag',
    sortable: true,
  },
  {
    Header: 'Changed by',
    accessor: 'changedBy',
    sortable: true,
  },
  {
    Header: 'Date/time of change',
    accessor: 'changedAt',
    sortable: true,
    Cell: ({ value }) => getUSDateTimeStr(value),
  },
  {
    Header: 'Number of changes',
    accessor: 'changeCount',
    sortable: false,
    Cell: ({ value }) => value || emDashUnicode,
  },
];

export const getLineHistorySubrow =
  (isSOP) =>
  ({
    row: {
      original: { changes, updates },
    },
  }) => {
    const changeCols = [
      {
        Header: 'Change type',
        accessor: 'tab',
        sortable: false,
      },
      ...(isSOP
        ? [
            {
              Header: 'Equipment category',
              accessor: 'category',
              sortable: false,
            },
            {
              Header: 'Equipment/color code',
              accessor: 'equipmentCode',
              sortable: false,
            },
          ]
        : []),
      {
        Header: 'Field name',
        accessor: 'fieldName',
        sortable: false,
      },
      {
        Header: 'Previous value',
        accessor: 'oldValue',
        sortable: false,
        Cell: ({ value }) => value || emDashUnicode,
      },
      {
        Header: 'Current value',
        accessor: 'newValue',
        sortable: false,
        Cell: ({ value }) => value || emDashUnicode,
      },
    ];

    const getValueCell = ({ value, row: { original } }) => {
      if (!value) return emDashUnicode;
      if (/date$/.test(original.fieldName))
        return getETDateTimeStr(value, ' ET');
      return value;
    };
    const updateCols = [
      {
        Header: 'Change type',
        accessor: 'tab',
        sortable: false,
      },
      {
        Header: 'Field name / operation',
        accessor: 'fieldName',
        sortable: false,
      },
      {
        Header: 'Previous value',
        accessor: 'oldValue',
        sortable: false,
        Cell: getValueCell,
      },
      {
        Header: 'Current value',
        accessor: 'newValue',
        sortable: false,
        Cell: getValueCell,
      },
      {
        Header: 'Updated by',
        accessor: 'updatedBy',
        sortable: false,
      },
      {
        Header: 'Updated at',
        accessor: 'updatedAt',
        sortable: false,
        Cell: ({ value }) => getUSDateTimeStr(value),
      },
    ];

    return (
      <section className="line-history-subrow">
        <div className="title-s-caps text-primary margin-top-1">
          Contract line version changes
        </div>
        <AFPTable data={changes || []} columns={changeCols} />
        {!changes.length && (
          <div className="margin-top-neg-2">
            <EmptyState topText="Contract version update. No contract line version change." />
          </div>
        )}
        {updates.length > 0 && (
          <>
            <div className="title-s-caps text-primary margin-top-4">
              Other contract line updates
            </div>
            <AFPTable data={updates} columns={updateCols} />
          </>
        )}
      </section>
    );
  };
